// --- Reusable Component ---
import { motion } from "framer-motion";

const BenefitCard = ({ icon: Icon, cardNumber, title, description }) => (
  <motion.div
    className="p-6 flex flex-col items-start gap-4 bg-white dark:bg-white/5 shadow-md rounded-lg border border-defaultBlack/5"
    variants={{
      hidden: { opacity: 0, y: 40 },
      visible: {
        opacity: 1,
        y: 0,
        transition: { delay: 0.2, duration: 0.7, ease: "easeOut" },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    {Icon ? (
      <div className="p-3 text-white rounded-lg bg-defaultGreen/80">
        <Icon size={24} />
      </div>
    ) : (
      <div className="bg-defaultGreen text-white w-12 h-12 flex items-center justify-center rounded-full p-3 font-bold text-lg">
        {cardNumber}
      </div>
    )}

    <h3 className="font-bold text-gray-900 dark:text-white uppercase tracking-wide">
      {title}
    </h3>
    <p className="text-gray-600 dark:text-white/70 leading-relaxed">
      {description}
    </p>
  </motion.div>
);

export default BenefitCard;
